import ComponentRepository from './architecture/componentRepository';
import setScrollbarCssVariables from './functionality/scrollbar-width-calculator';
import PageTransition from './functionality/page-transition';

document.addEventListener('DOMContentLoaded', function () {
    window.cr = new ComponentRepository({
        'add-ons': () => import('./components/add-ons'),
        'sticky-header': () => import('./components/sticky-header'),
        'read-more': () => import('./components/read-more'),
        'artists-slider': () => import('./components/artists-slider'),
        'additional-events': () => import('./components/additional-events'),
        'vue-component-loader': () => import('./components/vue-component-loader'),
        'scroll-sticker': () => import('./components/scroll-sticker'),
        'slide-in-modal': () => import('./components/slide-in-modal'),
        'modal': () => import('./components/modal'),
        'related-articles': () => import('./components/related-articles'),
        'event-page': () => import('./controllers/event-page'),
        'front-page': () => import('./controllers/front-page'),
        'calendar-page': () => import('./controllers/calendar-page'),
        'column-swiper': () => import('./components/column-swiper'),
        'top-navigation': () => import('./components/top-navigation'),
        'short-content': () => import('./components/short-content'),
        'font-resizer': () => import('./components/font-resizer'),
        'accordion': () => import('./components/accordion'),
        'hero-slider': () => import('./components/hero-slider'),
        'ticket-slider': () => import('./components/ticket-slider'),
        'article-overview': () => import('./components/article-overview'),
        'discover-music-section': () => import('./components/discover-music-section'),
        'alertbar': () => import('./components/alertbar'),
        'media-section': () => import('./components/media-section'),
        'sub-hero': () => import('./components/sub-hero'),
        'live-stream': () => import('./components/live-stream'),
        'mobile-slider': () => import('./components/mobile-slider'),
        'search': () => import('./components/search'),
        'event-presale': () => import('./components/event-presale'),
        'program-page': () => import('./controllers/program-page'),
        'ensemble-header': () => import('./components/ensemble-header'),
        'basket-controller': () => import('./components/basket-controller'),
        'fit-text': () => import('./components/fit-text'),
        'copy-text': () => import('./components/copy-text'),
        'add-ons-search': () => import('./components/add-ons-search'),
        'tours': () => import('./components/tours'),
        'tour-calendar': () => import('./components/tour-calendar'),
        'print-listener': () => import('./components/print-listener'),
    });
    window.cr.load();
    window.vuecr = new ComponentRepository({
        'vue-event-card': () => import('./components/vue/vue-event-card.vue'),
        'vue-events-list': () => import('./components/vue/vue-events-list.vue'),
        'vue-podcast': () => import('./components/vue/vue-podcast.vue'),
        'vue-feature-section': () => import('./components/vue/vue-feature-section.vue'),
        'vue-featured-events': () => import('./components/vue/vue-featured-events.vue'),
    });

    // Initialize Page transition
    window.pageTransition = new PageTransition();
    window.pageTransition.init();

    document.querySelectorAll('.mceNonEditable.embeditem').forEach(x => {
        if (x.dataset.embedWidth) {
            x.style.maxWidth = x.dataset.embedWidth + 'px';
        }
    });

    window.loadResource = function (entry) {
        const pictureTag = entry.target;
        const srcset = pictureTag.querySelectorAll('[data-srcset]');
        const src = pictureTag.querySelectorAll('[data-src]');
        srcset.forEach(source => {
            source.srcset = source.dataset.srcset;
            source.removeAttribute('data-srcset');
        });

        src.forEach(source => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');

            if (pictureTag.load) {
                try {
                    pictureTag.load();
                } catch (err) {
                }
            }
        });

        pictureTag.classList.remove('lazy');
        lazyImageObserver.unobserve(pictureTag);
    };

    function loadAll(lazyImages) {
        lazyImages.forEach((entry) => {
            window.loadResource({ target: entry });
        });
    }

    window.loadObserver = function (barba = false) {
        const lazyImages = [].slice.call(document.querySelectorAll('.lazy'));

        if (barba) {
            setTimeout(() => {
                loadAll(lazyImages);
            }, 2000);
        } else {
            document.addEventListener('readystatechange', () => {
                if (document.readyState == 'complete') {
                    loadAll(lazyImages);
                }
            });
        }

        if ('IntersectionObserver' in window) {
            function callback(entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        window.loadResource(entry);
                    }
                });
            }

            const options = {
                rootMargin: '1000px',
            };

            window.lazyImageObserver = new IntersectionObserver(callback, options);

            lazyImages.forEach(function (lazyImage) {
                window.lazyImageObserver.observe(lazyImage);
            });

        } else {
            // Not supported, load all images immediately
            lazyImages.forEach(function (image) {
                image.nextElementSibling.src = image.nextElementSibling.dataset.srcset;
            });
        }
    };

    window.loadObserver();

    const videos = document.querySelectorAll('video[autoplay]');
    function startVideos() {
        videos.forEach(video => {
            const isVideoPlaying = !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
            if (!isVideoPlaying) {
                video.play();
            }
        });
    }

    window.addEventListener('touchstart', startVideos);
    window.addEventListener('click', startVideos);

    // Set CSS variables to get proper vw units and scrollbar width. The size of the scrollbar depends on browser.
    setScrollbarCssVariables();
    import('lodash/throttle')
        .then(result => {
            return result.default;
        })
        .then(throttle => {
            window.addEventListener('resize', throttle(setScrollbarCssVariables, 100, { leading: false }));
        });

    document.addEventListener('submit', function (event) {
        const form = event.target;
        const validForms = {
            '#umbraco_form_9f98c5f87f4d4ec2b6ab47c45a849b6c form': 'default_form',
            '#umbraco_form_5586963585274a54848f8e9b540f2a53 form': 'musikariet_form',
        };
        for (const [selector, formName] of Object.entries(validForms)) {
            if (form.matches(selector) && !form.dataset.listenerHandled) {
                form.dataset.listenerHandled = 'true';
                window.dataLayer.push({
                    'event': 'newsletter_signup',
                    'form_name': formName,
                });
            }
        }
    });
});
